import {Suspense, useEffect,useRef} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit, useAuth} from './modules/auth'
import { CurrencyProvider } from '../_metronic/currency/CurrencyContextProvider'
import { Toaster, toast } from 'react-hot-toast'

import Echo from 'laravel-echo'
// @ts-ignore
import io from 'socket.io-client';

const App = () => {
  const {currentUser,auth} = useAuth()
  const echoRef = useRef<any>(null) // keep reference to echo instance

// useEffect(() => {
//   const testMode = false
//   if (!currentUser && !testMode) return

//   window.io = io

//   const echo = new Echo({
//     broadcaster: 'socket.io',
//     host: 'https://app-api-vpro-tt.taktelcom.com:6002',
//     key: 'test-key',
//     transports: ['websocket'],
//     forceTLS: true,
//     enabledTransports: ['ws', 'wss'],
//     disableStats: false,
//   })

//   echo.connector.socket.on('connect', () => {
//     console.log('✅ WebSocket connected')
//   })

//   echo.connector.socket.on('disconnect', (reason: string) => {
//     console.log('❌ Disconnected:', reason)
//   })

//   echo.connector.socket.on('connect_error', (error: Error) => {
//     console.error('🔥 Connection error:', error)
//   })

//   // 👇 Make sure this exact channel and event name is used
//   echo.channel('laravel_database_resellers-channel')
//     .listen('.UserEvent', (e: any) => {
//       console.log('🎯 Event received from server:', e)
//       if (e?.title) {
//         toast.success(e.title)
//       } else {
//         toast('📡 New event received')
//       }
//     })

//   // Optional: debug raw message
//   echo.connector.socket.on('message', (msg: any) => {
//     console.log('📦 Raw WebSocket message:', msg)
//   })
// })

useEffect(() => {
  if (!currentUser) {
    // 🔌 Disconnect WebSocket when user logs out
    if (echoRef.current) {
      console.log('👋 Logging out, disconnecting socket...')
      echoRef.current.disconnect()
      echoRef.current = null
    }
    return
  }
  // ✅ User is logged in, connect to WebSocket
  console.log('🔐 Logged in, connecting to WebSocket...')
  window.io = io

  const echo = new Echo({
    broadcaster: 'socket.io',
    host: 'https://app-api-vpro-tt.taktelcom.com:6002',
    // key: 'test-key',
    transports: ['websocket'],
    forceTLS: false,
    enabledTransports: ['ws', 'wss'],
    disableStats: false,  
    auth: {
      headers: {
        'Authorization': `Bearer ${auth?.api_token}`, // Pass token here if you're using it
        'Accept': 'application/json'

      },
    },
  })

  echo.connector.socket.on('connect', () => {
    console.log('✅ WebSocket connected')
  })

  echo.connector.socket.on('disconnect', (reason: string) => {
    console.log('❌ Disconnected:', reason)
  })

  echo.connector.socket.on('connect_error', (error: Error) => {
    console.error('🔥 Connection error:', error)
  })

  echo.channel('resellers-channel')
  
    .listen('.UserEvent', (e: any) => {
      console.log('🎯 Event received:', e)
      const audio = new Audio('/media/sounds/zapsplat_multimedia_notification_bell_chime_ring_alert_001_41155.mp3')
      audio.play().catch(err => console.warn('🔇 Sound playback failed:', err))
      if (e?.title) {
        toast.success(e.title)
      } else {
        toast('📡 New event received')
      }
    })

    // 🔔 2. Private Channel: Admin Notifications
    echo.channel('admin-notifications')
   
      .listen('.OrderPlacedEvent', (e: any) => {
        console.log('📢 Admin OrderPlaced event:', e)
        const audio = new Audio('/media/sounds/zapsplat_multimedia_notification_bell_chime_ring_alert_001_41155.mp3')
        audio.play().catch(err => console.warn('🔇 Sound failed:', err))
        toast.success(`${e.title}: ${e.message}`)
      })
  // Save reference for cleanup

  // this is for testing the reseller order confirmation or rejection

  // 🔔 2. Private Channel: Admin Notifications
  echo.channel('reseller-173-order-channel')
   
  .listen('.ChangeOrderStatus', (e: any) => {
    console.log('📢 Admin Confirmed event:', e)
    const audio = new Audio('/media/sounds/zapsplat_multimedia_notification_bell_chime_ring_alert_001_41155.mp3')
    audio.play().catch(err => console.warn('🔇 Sound failed:', err))
    toast.success(`${e.title}: ${e.message}`)
  })
// Save reference for cleanup
  echoRef.current = echo

  return () => {
    console.log('♻️ Cleanup WebSocket connection')
    echo.disconnect()
  }
}, [currentUser])
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <CurrencyProvider>
        <I18nProvider>
          <LayoutProvider>
            <AuthInit>
              <Outlet />
              <MasterInit />
              <Toaster position="top-right" />
            </AuthInit>
          </LayoutProvider>
        </I18nProvider>
      </CurrencyProvider>
    </Suspense>
  )
}

export {App}
